import { useQuery } from "@tanstack/vue-query";
import { api } from "@/api";
import { type Pitch } from "./bookings";
import { type Ref, computed } from "vue";

export const PITCHES_QUERY_KEY = "pitches";

export const listPitches = async (siteId: string | null | undefined) => {
  const { body } = await api.get<Pitch[]>("/pitchs", {
    query: siteId ? { site_id: siteId } : undefined,
  });

  return body;
};

export const usePitches = (siteId: Readonly<Ref<string | null>>) => {
  return useQuery({
    queryKey: [PITCHES_QUERY_KEY, siteId],
    queryFn: () => listPitches(siteId.value),
    staleTime: 5 * 60 * 1000,
  });
};
